import React from 'react';
import {
  SectionContainer,
  SectionHeaderWrapper,
  EntitlementList,
  FeatureRow,
  FeatureName,
  FeatureNameButton,
  FeatureValueCell,
  FeatureNameText,
  FeatureNameLastWord,
  FeatureToolTip,
  CellAnnouncement,
} from './index.styles';
import { InfoIcon } from '@nebula/icons/ui';
import uiIconSizes from '@nebula/icons/ui/iconSizes';
import nebulaTheme from '@nebula/theme';
import type { PlanTableProps } from '../../types';
import EntitlementValue from '../../shared/EntitlementValue';
import EntitlementSectionTitle from '../../shared/EntitlementSectionTitle';
import { getEntitlementCellAnnouncement, splitTrailingWord } from '../../utils';

const PlanTable: React.FC<PlanTableProps> = ({ orderedPlans, featureSections, onSelectFeature }) => {
  return (
    <>
      {featureSections.map(section => {
        return (
          <SectionContainer key={section.id}>
            <SectionHeaderWrapper>
              <EntitlementSectionTitle section={section} />
            </SectionHeaderWrapper>
            <EntitlementList>
              {section.features.map(feature => {
                const [labelStart, labelLastWord] = splitTrailingWord(feature.label);

                return (
                  <FeatureRow key={feature.label}>
                    <FeatureName>
                      <FeatureNameButton
                        type="button"
                        onClick={() => onSelectFeature(feature)}
                        aria-label={`${feature.label}. Learn more.`}
                      >
                        <FeatureNameText>
                          {labelStart}
                          <FeatureNameLastWord>
                            {labelLastWord}
                            <FeatureToolTip aria-hidden="true">
                              <InfoIcon iconSize={uiIconSizes.xxSmall} iconColor={nebulaTheme.color.ui.blue[70]} />
                            </FeatureToolTip>
                          </FeatureNameLastWord>
                        </FeatureNameText>
                      </FeatureNameButton>
                    </FeatureName>
                    {orderedPlans.map(plan => (
                      <FeatureValueCell key={plan.id}>
                        <CellAnnouncement>
                          {getEntitlementCellAnnouncement(plan.cardTitle, feature.label, feature.values[plan.id])}
                        </CellAnnouncement>
                        <EntitlementValue value={feature.values[plan.id]} />
                      </FeatureValueCell>
                    ))}
                  </FeatureRow>
                );
              })}
            </EntitlementList>
          </SectionContainer>
        );
      })}
    </>
  );
};

export default PlanTable;
